export default __webpack_public_path__ + "static/radiografia-27e6e4b04adb2ebb11b74207f278e32d.png";